import React from 'react'

/**
 * Button component for use in Cushion Designer
 *
 * @component
 *
 * @param {Object} params - The properties of the Button component
 * @param {string} [params.rounded = 'rounded-full'] - Rounded tw class for the button
 * @param {string} [params.className = ''] - Additional custom tw classes
 * @param {'base' | 'primary' | 'primaryIcon' | 'secondaryIcon'} [params.variant = 'base'] - Button's variant defined in component's file
 * @param {boolean} [params.disabled] - Disabled state for button
 * @param {ReactNode} params.children - The button's content
 * @param {function} params.onClick - Function that is called when the button is triggered
 * @param {string} [params.id] - Button's id
 * @returns {ReactElement} Button Component
 */
const Button = ({
  className = '',
  variant = 'base',
  datatestid = '',
  disabled,
  children,
  onClick,
  id,
}) => {
  return (
    <button
      className={`redesign-button ${variant ? `button-${variant}` : ''} ${className}`}
      type="button"
      disabled={disabled}
      onClick={onClick}
      data-testid={datatestid}
      id={id}
    >
      {children}
    </button>
  )
}

export default Button
